import css from './OfficeVolumes.module.scss';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import UserContext, { UserProfileContext } from '../../../../common/utils/getContext';
import CardWithIcon from '../../../../widgets/cardWithIcon/CardWithIcon';
import T from '../../../../common/components/T';
import { Tooltip, svgSprite } from '../../../../hybrid/wrappers';
import Button from '../../../../widgets/secondaryButton/Button';
import BranchDetails from './components/BranchDetails/BranchDetails';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import Slider from 'react-slick';
import classNames from 'classnames';
import { dataSender, getData } from '../../../../common/utils/router';
import Modal from '../../../../widgets/modal/Modal';
import FormButtons from '../../../../widgets/form/form-control-buttons/FormButtons/FormButtons';
import { API_SERVER_URL } from '../../../../common/utils/utils';
import { createCashbackInfoGrid } from './helpers';
import GridComponent from '../../../../widgets/grid/GridComponent/GridComponent';
import ContentAlert from '../../../../widgets/contentAlert/ContentAlert';

function formatValue(val = '', onlyValue) {
    if (typeof val.trim() !== 'string') return '-';
    let number = '';
    let curr = '';

    for (const symb of val) {
        if (!isNaN(symb) || symb === '.' || symb === '-') {
            number += symb.trim();
        } else {
            curr += symb;
        }
    }
    if (onlyValue) {
        return {
            value: (+number).toLocaleString(),
            curr: curr
        };
    }
    return (
        <p>
            <span className={css.volumeValue}>{(+number).toLocaleString()}</span>
            <span> </span>
            <span className={css.volumeCurr}>{curr}</span>
        </p>
    );
}

const VolumeCardContent = ({ volume = {}, clickHandler, position, hideHint, hideBtn, formatted_value }) => {
    const value = formatValue(volume.formatted_value_self, true);

    return (
        <div className={css.cardContent}>
            <div className={css.cardLine}></div>
            <div className={css.cardContentTitle}>
                <p className={css.cartContentTitleText}>
                    <T
                        textName='volume_personal_invited_self'
                        defaultStr='Объем от структуры лично-приглашенных'
                        page='/office'
                    />
                </p>
                {!hideHint ? (
                    <Tooltip
                        text={
                            +position === 1 ? (
                                <T
                                    textName='left-branch-volume-your-binar-structure'
                                    defaultStr='Объем от структуры лично приглашенных в левой ветке'
                                    page='/office'
                                />
                            ) : (
                                <T
                                    textName='right-branch-volume-your-binar-structure'
                                    defaultStr='Объем от структуры лично приглашенных в правой ветке'
                                    page='/office'
                                />
                            )
                        }
                        mobileText={
                            +position === 1 ? (
                                <T
                                    textName='left-branch-volume-your-binar-structure'
                                    defaultStr='Объем от структуры лично приглашенных в левой ветке'
                                    page='/office'
                                />
                            ) : (
                                <T
                                    textName='right-branch-volume-your-binar-structure'
                                    defaultStr='Объем от структуры лично приглашенных в правой ветке'
                                    page='/office'
                                />
                            )
                        }
                    >
                        <div className={css.cartTitleIcon}>
                            {svgSprite('question-circle-fill', { className: classNames(css.cardTitleCircle, 'tooltipShadow') })}
                        </div>
                    </Tooltip>
                ) : null}
            </div>
            <p className={css.cardVolumeSelf}>{formatted_value || `${value?.value} ${value?.curr}`}</p>
            {!hideBtn ? (
                <Button
                    type='small'
                    title={<T textName='more-details' defaultStr='Подробнее' page='/office' />}
                    clickHandler={clickHandler}
                />
            ) : null}
        </div>
    );
};

const CashbackCardContent = ({ profileData }) => {
    const { userToken, lang, marketingCurrency, setAlertData } = useContext(UserContext);

    const [cashback, setCashback] = useState(null);
    const [cashbackMeta, setCashbackMeta] = useState(null);
    const [cashbackModal, setCashbackModal] = useState(false);

    const [cashbackInfoModal, setCashbackInfoModal] = useState(false);
    const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(false);

    useEffect(() => {
        getData('/api/v1/user/marketing/cashback', userToken, lang).then((res) => {
            if (res?.data) setCashback(res?.data);
            if (res?.meta) setCashbackMeta(res?.meta);
        });
    }, [userToken, lang]);

    const withdrawalCashback = useCallback(() => {
        setConfirmButtonDisabled(true);
        dataSender(
            `${API_SERVER_URL}/api/v1/user/marketing/cashback/pay`,
            'POST',
            null,
            () => {
                setAlertData({
                    type: 'success',
                    cont: <T textName='cashback_withdrawal_success_message' defaultStr='Cashback успешно выведен' />
                });
                setCashbackModal(false);
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            },
            (error) => {
                setAlertData({
                    type: 'error',
                    cont: error?.message || <T textName='error_occured' defaultStr='Произошла ошибка' />
                });
                setConfirmButtonDisabled(false);
            },
            userToken,
            lang
        );
    }, [userToken, lang, setAlertData]);

    const cashbackInfoGrid = useMemo(() => {
        return createCashbackInfoGrid(cashbackMeta);
    }, [cashbackMeta]);

    if (!Boolean(cashback)) return null;
    return (
        <>
            <div className={css.cardLine}></div>
            <div className={css.cardCashback}>
                <div className={css.cardCashbackLeft}>
                    <div className={css.cardContentTitle}>
                        <p className={css.cartContentTitleText}>
                            <T textName='cashback' defaultStr='Cashback' />
                        </p>
                        <Tooltip text={<T textName='cCashback_for_current_volume' defaultStr='Cashback за текущий объем' />}>
                            <div className={css.cartTitleIcon}>
                                {svgSprite('question-circle-fill', {
                                    className: classNames(css.cardTitleCircle, 'tooltipShadow')
                                })}
                            </div>
                        </Tooltip>
                    </div>
                    <p className={css.cardVolumeSelf}>{`${Number(cashback?.amount).toLocaleString()} ${
                        marketingCurrency?.symbol || ''
                    }`}</p>
                    <Tooltip
                        text={
                            !cashback?.allowed ? (
                                <T
                                    textName='withdraw_cashback_disabled'
                                    defaultStr='Выполните условия активности для доступу к Cashback'
                                />
                            ) : (
                                ''
                            )
                        }
                    >
                        <div
                            className={classNames(
                                css.cashbackButton,
                                (!cashback?.allowed || cashback?.amount <= 0) && css.cashbackButtonDisabled
                            )}
                        >
                            <Button
                                type='tiny'
                                title={<T textName='write_off_to_cashback_lo' defaultStr='Обнулить ЛО и получить Cashback' />}
                                clickHandler={setCashbackModal}
                            />
                        </div>
                    </Tooltip>
                </div>
                <div className={css.cardCashbackRight}>
                    <div className={css.cardContentTitle}>
                        <p className={css.cartContentTitleText}>
                            <T textName='cumulative_total_personal_volume_short' defaultStr='НЛО' />
                        </p>
                        <Tooltip text={<T textName='cumulative_total_personal_volume' defaultStr='Накопительный личный объем' />}>
                            <div className={css.cartTitleIcon}>
                                {svgSprite('question-circle-fill', {
                                    className: classNames(css.cardTitleCircle, 'tooltipShadow')
                                })}
                            </div>
                        </Tooltip>
                    </div>
                    <p className={css.cardVolumeSelf}>
                        {`${Number(+profileData?.marketing_profile?.cumulative_total_personal_volume?.value).toLocaleString()} ${
                            marketingCurrency?.symbol || ''
                        }`}
                    </p>
                    <div className={css.cashbackButton}>
                        <Button
                            type='tiny'
                            title={<T textName='more-details' defaultStr='Подробнее' page='/office' />}
                            clickHandler={setCashbackInfoModal}
                        />
                    </div>
                </div>
            </div>
            {cashbackModal ? (
                <Modal
                    customStyles={{ modal: css.cashbackModal }}
                    useAnimation={true}
                    closeHandler={() => setCashbackModal(false)}
                >
                    <p className={css.cashbackModalTitle}>
                        <T textName='cashback_withdrawal' defaultStr='Вывод на Cashback' />
                    </p>
                    <div className={css.cashbackModalContent}>
                        <div className={css.cashbackModalItem}>
                            <p className={css.cashbackModalItemTitle}>
                                <T textName='personal_volume' defaultStr='Личный объем' />
                            </p>
                            <p className={css.cashbackModalItemValue}>
                                {formatValue(profileData?.marketing_profile?.total_personal_volume?.formatted_value)}
                            </p>
                        </div>
                        <div className={css.cashbackModalSeparator}>
                            <svg viewBox='0 0 120 24'>
                                <line x1='0' y1='12' x2='110' y2='12' stroke-width='1' />
                                <line x1='110' y1='12' x2='100' y2='6' stroke-width='1' />
                                <line x1='110' y1='12' x2='100' y2='18' stroke-width='1' />
                            </svg>
                        </div>
                        <div className={css.cashbackModalItem}>
                            <p className={css.cashbackModalItemTitle}>
                                <T textName='cashback' defaultStr='Cashback' />
                            </p>
                            <p className={css.cashbackModalItemValue}>{formatValue(cashback?.formatted?.amount)}</p>
                        </div>
                    </div>
                    <ContentAlert
                        message={
                            <div>
                                <T
                                    textName='cashback_info'
                                    defaultStr='При получении Cashback -> ваш личный объем уменьшится до 0 PV'
                                />
                            </div>
                        }
                        type='info'
                    />
                    <div className={css.cashbackModalButtons}>
                        <FormButtons
                            sendFormData={withdrawalCashback}
                            buttons={[
                                {
                                    type: 'cancel',
                                    clickFunc: () => setCashbackModal(false)
                                },
                                {
                                    type: 'ok',
                                    buttonText: <T textName='withdraw_cashback' defaultStr='Получить' />,
                                    disabled: confirmButtonDisabled
                                }
                            ]}
                        />
                    </div>
                </Modal>
            ) : null}
            {cashbackInfoModal ? (
                <Modal useAnimation={true} closeHandler={() => setCashbackInfoModal(false)}>
                    <p className={classNames(css.cashbackModalTitle, css.cashbackModalTitleInfo)}>
                        <T textName='cumulative_total_personal_volume' defaultStr='Накопительный личный объем' />
                    </p>
                    <p className={css.cashbackModalTitle}>
                        {formatValue(profileData?.marketing_profile?.cumulative_total_personal_volume?.formatted_value)}
                    </p>
                    <p className={css.cashbackInfoModalText}>
                        <T
                            textName='cashback_info_modal_text'
                            defaultStr='Накапливая личный объём, вы можете увеличить размер получаемого Cashback. Процент конвертации Личного объёма в cashback ниже'
                        />
                        .
                    </p>
                    <GridComponent viewData={cashbackInfoGrid?.tbody} viewThead={cashbackInfoGrid?.thead} />
                </Modal>
            ) : null}
        </>
    );
};

export default function OfficeVolumes() {
    const { profileData } = useContext(UserProfileContext);
    const [branchDetailsModal, showBranchDetailsModal] = useState(false);
    const width = useWindowDimensions();
    const sliderReference = useRef();

    const volumes = useMemo(() => {
        if (!profileData) return [];
        const marketingProfile = profileData?.marketing_profile;

        const personalProgress = {
            ...(marketingProfile?.personal_volume || {}),
            name: <T textName='personal_volume' defaultStr='Личный объем' />,
            icon: 'user-fill-colored',
            formatted_value: formatValue(marketingProfile?.total_personal_volume?.formatted_value),
            component: <CashbackCardContent profileData={profileData} />
        };

        const group_volume = {
            ...(marketingProfile?.group_volume || {}),
            name: <T textName='group_volume' defaultStr='Групповой объем' />,
            icon: 'users-fill-colored',
            formatted_value: formatValue(marketingProfile?.total_group_volume?.formatted_value)
        };
        const leftVolumeByPeriod = (
            marketingProfile?.structure_period_volumes?.data || marketingProfile?.structure_period_volumes
        )?.find((vol) => vol?.position === 1)?.volume;
        const leftVolume = (marketingProfile?.structure_volumes?.data || marketingProfile?.structure_volumes)?.find(
            (vol) => vol?.position === 1
        )?.volume;
        const leftBranchVolume = {
            ...(leftVolumeByPeriod || {}),
            name: <T textName='left_branch_volume' defaultStr='Объем левой ветки' />,
            icon: 'left-branch-fill-colored',
            formatted_value: formatValue(leftVolume?.formatted_value),
            component: (
                <VolumeCardContent
                    volume={leftVolumeByPeriod}
                    hideHint={true}
                    clickHandler={() => showBranchDetailsModal(1)}
                    position={1}
                />
            )
        };
        const rightVolumeByPeriod = (
            marketingProfile?.structure_period_volumes?.data || marketingProfile?.structure_period_volumes
        )?.find((vol) => vol?.position === 2)?.volume;
        const rightVolume = (marketingProfile?.structure_volumes?.data || marketingProfile?.structure_volumes)?.find(
            (vol) => vol?.position === 2
        )?.volume;
        const rightBranchVolume = {
            ...(rightVolumeByPeriod || {}),
            name: <T textName='right_branch_volume' defaultStr='Объем правой ветки' />,
            icon: 'right-branch-fill-colored',
            formatted_value: formatValue(rightVolume?.formatted_value),
            component: (
                <VolumeCardContent
                    volume={rightVolumeByPeriod}
                    hideHint={true}
                    clickHandler={() => showBranchDetailsModal(2)}
                    position={2}
                />
            )
        };
        return [personalProgress, group_volume, leftBranchVolume, rightBranchVolume];
    }, [profileData]);

    const settings = {
        ref: sliderReference,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: 'officeVolumesCard'
    };

    const goNextSlide = () => {
        sliderReference.current.slickNext();
    };

    const goPrevSlide = () => {
        sliderReference.current.slickPrev();
    };

    const cardProps = { goNextSlide, goPrevSlide };
    return (
        <div className={css.wrapper}>
            {width < 768 ? (
                <Slider {...settings}>
                    {volumes.map((volume) => (
                        <CardWithIcon key={volume.id} {...volume} {...cardProps} />
                    ))}
                </Slider>
            ) : (
                volumes.map((volume) => <CardWithIcon key={volume.id} {...volume} />)
            )}
            {branchDetailsModal ? (
                <BranchDetails branch={branchDetailsModal} closeHandler={() => showBranchDetailsModal(false)} />
            ) : null}
        </div>
    );
}
